import { getAmplitudeInstance } from '../amplitudeHelpers';

type logTrailDetailsAlertsViewedParams = {
  alert_count: number;
  trail_id: number;
};

/**
 * User sees alerts on the trail details page. Fires once per trail page visit when alerts first becomes visible. Only fires for trails that have at least one alert.
 * @param params - Attributes to log with the amplitude event
 * @param params.alert_count - The number of alerts present on the trail at the time the banner was viewed.
 * @param params.trail_id - The trail id of the associated trail details page.
 */
const logTrailDetailsAlertsViewed = ({ alert_count, trail_id }: logTrailDetailsAlertsViewedParams, callback?: () => void) => {
  getAmplitudeInstance().logEvent('trail details alerts viewed', { 'alert count': alert_count, 'trail id': trail_id }, callback);
};

export default logTrailDetailsAlertsViewed;
